// @flow

import React from 'react';
import ResultCard from 'components/ResultCard/ResultCard.js';
import ResultCardContainer from 'components/ResultCardContainer/ResultCardContainer.js';
import ResultData from 'components/ResultData/ResultData.js';
import Row from 'react-aaui/lib/grid/Row';
import Col from 'components/Col/Col';
import { transKilometersAsUnit } from 'services/newton';
import { getFinalResultPace } from '../../duck/selector';
import './AverageSpeedBoard.scss';

type Props = {
  formatMessage: Function,
  finalResult: Object
}

const AverageSpeedBoard = ({ formatMessage, finalResult }: Props) => {
  const { distanceUnit, averageSpeed } = finalResult || {};
  const displayAverageSpeed = averageSpeed >= 0 && distanceUnit ? `${transKilometersAsUnit(averageSpeed, distanceUnit)}` : '--';
  const displaySpeedUnit = distanceUnit ? formatMessage(`app.domain.result.speed.unit.${distanceUnit}`) : '--';
  const paceData = getFinalResultPace(formatMessage, finalResult || {});

  return (
    <Row fluid>
      <Col span={6} xl={12}>
        <ResultCardContainer className="margin-bottom average-pace">
          <ResultCard logo="icon-pace">
            <ResultData
              type={formatMessage('page.participant.participantHeader.averagePace')}
              data={paceData.value}
              other={paceData.unit}
              dataFont={20} />
          </ResultCard>
        </ResultCardContainer>
      </Col>
      <Col span={6} xl={12}>
        <ResultCardContainer className="margin-bottom average-speed">
          <ResultCard logo="icon-speed">
            <ResultData
              type={formatMessage('page.participant.participantHeader.averageSpeed')}
              data={displayAverageSpeed}
              other={displaySpeedUnit}
              dataFont={20} />
          </ResultCard>
        </ResultCardContainer>
      </Col>
    </Row>
  );
};

export default AverageSpeedBoard;